import type React from 'react';

import { DeepfakeIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface DeepfakeAttributeCardProps extends WithDataTestid, WithClassNameProp {
  deepfake: 0 | 1 | null;
}

export function DeepfakeAttributeCard({
  deepfake,
  className = undefined,
  'data-testid': dataTestId = 'DeepfakeAttributeCard',
  ...props
}: DeepfakeAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  let description: string;
  let color: 'positive' | 'negative' | null = null;

  switch (deepfake) {
    case null:
      description = t('shared:attribute_cards.deepfake.no_check');
      break;

    case 1:
      description = t('shared:attribute_cards.deepfake.real');
      color = 'positive';
      break;

    default:
      description = t('shared:attribute_cards.deepfake.fake');
      color = 'negative';
  }

  const colorsConfig = [{ color, tooltip: null }];

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={deepfake}
      data-testid={dataTestId}
      description={description}
      icon={<DeepfakeIcon />}
      title={t('shared:attribute_cards.deepfake.title')}
      {...props}
    />
  );
}
